import {
  SingleProviderConfig,
  ShopType,
  CheckoutType,
  CrossSellType,
} from 'types';
import { allLeadMode, getDefaultCrossSellAction } from 'config';
import {
  Comcast,
  Cox,
  Spectrum,
  Optimum,
  Wave,
  Grande,
  RCN,
  WOW,
  TDS,
  BuckeyeBroadband,
  Mediacom,
  ATT,
  Brightspeed,
  BrightspeedV2,
  CenturyLink,
  QuantumFiber,
  Frontier,
  Windstream,
  CincinnatiBell,
  Verizon,
} from 'config/providers';
import { WOWTheme } from 'config/themes';

export const WOWWaySpecial: SingleProviderConfig = {
  name: 'WOWWaySpecial',
  micrositeCode: 'wow',
  mainProvider: WOW,
  shopType: ShopType.SINGLE_PROVIDER,
  domain: 'wowwayspecial.com',
  homepage: 'https://wowwayspecial.com',
  title: 'Bundle - WOW! Special',
  fallbackPhoneNumber: '877-202-8450',
  fallbackLeadModePhoneNumber: '877-202-8450',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: WOWTheme,
  needsDcSession: false,
  source: 'WOW',
  noOffersRetry: 2,
  getCrossSellAction: getDefaultCrossSellAction,
  getCheckoutType: allLeadMode,
  crossSellProviders: [
    Comcast,
    Cox,
    Spectrum,
    Mediacom,
    Optimum,
    Wave,
    Grande,
    RCN,
    TDS,
    BuckeyeBroadband,
  ],
  updaterCrossSellActive: true,
  updaterCrossSellProviders: [
    ATT,
    Verizon,
    Brightspeed,
    BrightspeedV2,
    CenturyLink,
    QuantumFiber,
    Frontier,
    Windstream,
    CincinnatiBell,
  ],
};
